import React from 'react'

import { Spinner } from '@percent/lemonade'
import style from './Loader.module.scss'
import { LoaderProps } from './Loader.types'

export function Loader({ loaderStyle = 'loader', size = 10 }: LoaderProps) {
  return (
    <div className={style[loaderStyle]} data-testid="loading">
      <Spinner size={size} color="primary" />
    </div>
  )
}
